import { Address } from './address';

export enum StatusImageTypes {
  hot = 'assets/images/ribbon_hot.png',
  warm = 'assets/images/ribbon_warm.png',
  cold = 'assets/images/ribbon_cold.png',
}

export interface Applicant {
  id: number;
  firstName: string;
  lastName: string;
  image?: string;
  address?: Address;
  mobile?: string;
  email?: string;
  webSite?: string;
  currentTitle?: string;
  jobMatched?: string;
  jobApplied?: string;
  applyDate?: string;
  previousCompany?: string;
  currentCompany?: string;
  currentCompanyDuration?: string;
  experience?: string;
  skills?: string;
  status?: string;
  createdDate?: Date;
  irpJobId?: string;
  matchedJobId?: number;
  label?: string;
}
